export enum EBitfPQueryOperator {
  AND,
  OR,
}
